<template>
  <div class="come">
    <Header />
    <Nav />
    <div class="come-container">
        <img src="../assets/come/bg.png" alt="" class="come-container-bg">
        <div class="come-box">
            <div class="come-btns">
                <div class="btn" @click="goJoin">讲师入驻申请</div>
                <div class="btn" @click="goJoin">机构入驻申请</div>
            </div>
            <img src="../assets/come/box.png" alt="">
        </div>
    </div>
    <Fixed/>
     <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Nav from "@/components/Nav.vue";
import Footer from "@/components/Footer.vue";
import Fixed from "../components/Fixed.vue";
export default {
  name: "Come",
  components: {
    Header,
    Footer,
      Nav,
      Fixed
    },
    methods: {
        goJoin() {
            this.$router.push('/join')
        }
  }
}
</script>

<style lang="less" scoped>
.come {
    &-container {
        max-width: 1920px;
        position: relative;
        line-height: 0;
        margin: 0 auto;
        &-bg {
            width: 100%;
        }
    }
    &-box {
        width: 68.75vw;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 22px;
        img {
            width: 100%;
        }
    }
    &-btns {
        margin-bottom: 64px;
        display: flex;
        justify-content: center;
        .btn {
            width: 210px;
            height: 56px;
            background: linear-gradient(90deg, #FD441F 0%, #D93B33 100%, #D93B33 100%);
            box-shadow: 0px 2px 11px 0px rgba(165,3,3,0.78);
            border-radius: 8px 4px 4px 4px;
            border: 2px solid #FFFFFF;
            font-size: 24px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 56px;
            text-align: center;
            cursor: pointer;
            &:first-child {
                margin-right: 100px;
            }
        }    
    }
}
</style>